import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'schedulingtype'

const SchedulingTypeModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default SchedulingTypeModule



// WEBPACK FOOTER //
// ./src/store/module/schedulingtype/index.js